import { tenantAdminService } from "@/services/tenant-admin-service";
import type {
  TenantProfile,
  UpdateTenantProfileDto,
} from "@/types/tenant-profile";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const tenantProfileKeys = {
  all: ["tenantProfile"] as const,
  profile: () => [...tenantProfileKeys.all, "profile"] as const,
  logoUrl: () => [...tenantProfileKeys.all, "logoUrl"] as const,
};

export const useTenantProfile = (enabled = true) => {
  return useQuery<TenantProfile>({
    queryKey: tenantProfileKeys.profile(),
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: () => tenantAdminService.getTenantProfile(),
  });
};

export const useUpdateTenantProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateTenantProfileDto) =>
      tenantAdminService.updateTenantProfile(payload),
    onSuccess: (profile) => {
      queryClient.setQueryData(tenantProfileKeys.profile(), profile);
    },
  });
};

export const useTenantLogoUrl = (enabled = true) => {
  return useQuery<string>({
    queryKey: tenantProfileKeys.logoUrl(),
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: () => tenantAdminService.getTenantLogoUrl(),
  });
};
